import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, input, OnDestroy } from "@angular/core";
import { ResizeImageMapsDirective } from "./resize-image-maps.directive";
import { ReplaceBigTablesDirective } from "./replace-big-tables.directive";
import { LazyReferenceResolverDirective } from "./lazy-reference-resolver.directive";
import { DescriptionHtmlPipe } from "common/editor/description-html.pipe";

type ResizeCallback = (size: { width: number; height: number }) => void;

@Component({
	selector: "stages-description-view",
	templateUrl: "./description-view.component.html",
	styleUrls: ["./description-view.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ResizeImageMapsDirective, ReplaceBigTablesDirective, LazyReferenceResolverDirective, DescriptionHtmlPipe],
})
export class DescriptionViewComponent implements AfterViewInit, OnDestroy {
	private elem = inject(ElementRef);
	private readonly resizeObserver: ResizeObserver;
	readonly descriptionId = input<string>();
	readonly descriptionClass = input<string>();
	readonly html = input.required<string>();
	readonly workspaceId = input<string>();
	resizeHandlers = new Map<string, ResizeCallback>();

	constructor() {
		this.resizeObserver = new ResizeObserver((entries) => {
			const entry = entries[0];
			if (entry) {
				const size = {
					width: entry.contentRect.width,
					height: entry.contentRect.height,
				};
				for (const handler of this.resizeHandlers.values()) {
					handler(size);
				}
			}
		});
	}

	ngAfterViewInit(): void {
		this.resizeObserver.observe(this.elem.nativeElement.parentNode);
	}

	registerResizeHandler(name: string, handler: ResizeCallback): void {
		this.resizeHandlers.set(name, handler);
	}

	ngOnDestroy(): void {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	}
}
